import { render, staticRenderFns } from "./EditScene.vue?vue&type=template&id=b1e8410e&scoped=true&"
import script from "./EditScene.vue?vue&type=script&lang=js&"
export * from "./EditScene.vue?vue&type=script&lang=js&"
import style0 from "./EditScene.vue?vue&type=style&index=0&id=b1e8410e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e8410e",
  null
  
)

export default component.exports